(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ibd-breadcrumbs"] && !Shopify.designMode) return;
  try {
    class IbdBreadcrumbs extends HTMLElement {
    constructor() {
      super();
    }
  }

  if (!customElements.get('ibd-breadcrumbs')) {
    customElements.define('ibd-breadcrumbs', IbdBreadcrumbs);
  }
  } catch(e) { console.error(e); }
})();

})();
